import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { selectors as searchFiltersSelectors } from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import {
  effects as searchPageEffects,
  selectors as searchPageSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';

import AdvancedFiltersBottomSheet from './AdvancedFiltersBottomSheet';

export type Props = {
  isOpen: boolean;
  onClose: (scrollToResults: boolean) => void;
};
const effects = {
  updateFiltersAndFireSearchOnChange: searchPageEffects.updateFiltersAndFireSearchOnChange,
};

const selector = (state) => ({
  searchFilters: searchFiltersSelectors.getFilters(state),
  priceFilterMinValue: searchPageSelectors.getPriceFilterMinValue(state),
  priceFilterMaxValue: searchPageSelectors.getPriceFilterMaxValue(state),
});

const AdvancedFiltersBottomSheetContainer = (props: Props): JSX.Element => (
  <Connect effects={effects} selector={selector}>
    {(connectedProps) => <AdvancedFiltersBottomSheet {...connectedProps} {...props} />}
  </Connect>
);

export default AdvancedFiltersBottomSheetContainer;
